module.exports = __webpack_public_path__ + "static/media/team-icon.837c67c3.svg";